import { Component, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Sidebar } from '../sidebar/sidebar';
import { Topbar } from '../topbar/topbar';
import { TopLoader } from '../../core/components/top-loader/top-loader';

@Component({
  selector: 'app-shell',
  standalone: true,
  imports: [RouterOutlet, Sidebar, Topbar, TopLoader],
  template: `
    <!-- Global progress bar — sits above everything, z-index 9999 -->
    <app-top-loader />

    <app-sidebar [collapsed]="sidebarCollapsed()" (toggle)="toggleSidebar()" />

    <div class="main" [class.collapsed]="sidebarCollapsed()">
      <app-topbar (menuToggle)="toggleSidebar()" />
      <router-outlet />
    </div>

    <div class="watermark">TRENDLY ADMIN · v1.0</div>
  `
})
export class Shell {
  sidebarCollapsed = signal(false);

  toggleSidebar() {
    if (window.innerWidth < 768) {
      document.querySelector('.sidebar')?.classList.toggle('show');
    } else {
      this.sidebarCollapsed.update(v => !v);
    }
  }
}
